import * as React from 'react';
import { useEffect, useState } from "react";
import './index.css'
import { useNavigate } from 'react-router-dom';
import { DOMAINCLIENT } from "../../Constant";
import "sweetalert2/dist/sweetalert2.css";
import axiosInstance from '../../utilities/axiosInstance';
import { FiCalendar } from 'react-icons/fi';
import { Listbox } from "@headlessui/react";
import { FaChevronDown, FaCheck } from "react-icons/fa";
import { FiChevronLeft, FiChevronRight } from 'react-icons/fi';
import { TbDotsVertical } from "react-icons/tb";
import clsx from "clsx";
import Modal from '@mui/material/Modal'; //5.5.2
import CreateProject from "../project/CreateProject";
import { showAlert } from "../AlertPopup";
import { useSearch } from '../../context/SearchContext';
import commonFunction from '../../utilities/commonFunction';
import Loader from '../Loader';

const Project = () => {
    const navigate = useNavigate();
    const [projects, setProjects] = useState([]);
    const [filterData, setFilterData] = useState([]);
    const [clientFilterData, setClientFilterData] = useState([]);
    const [projectFilterData, setProjectFilterData] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [recordsPerPage, setRecordsPerPage] = useState([]);
    const [totalPages, setTotalPages] = useState(0);
    const [showDetailsMenu, setShowDetailsMenu] = useState(false);
    const [selectedCard, setSelectedCard] = useState(null);
    const [showDateFilterPopup, setShowDateFilterPopup] = useState(false);
    const detailsMenuFields = ['Edit', 'Delete', 'Export'];
    const dateFilterSelectFieldsOptions = ['Between', '<', '>'];
    const [selectedDateFilterField, setSelectedDateFilterField] = useState('');
    const [startDateForDateFilter, setStartDateForDateFilter] = useState(null);
    const [endDateForDateFilter, setEndDateForDateFilter] = useState(null);
    const [selectedClientFilter, setSelectedClientFilter] = useState(null);
    const [selectedProjectFilter, setSelectedProjectFilter] = useState(null);
    const [componentKey, setComponentKey] = useState(1);
    const pageSize = 12;
    const [isLoading, setIsLoading] = useState(false);

    //5.5.2
    const [open, setOpen] = useState(false);
    const [exportFormat, setExportFormat] = useState('');
    const [saveImages, setSaveImages] = useState(false);
    const [customName, setCustomName] = useState('');
    const [defaultSettings, setDefaultSettings] = useState(true);
    const [exportFormatError, setExportFormatError] = useState('');
    const [successMessage, setSuccessMessage] = useState('');
    const [exportProjectData, setExportProjectData] = useState(null);
    const [createModalOpen, setCreateModalOpen] = useState(false);
    const [receiveProjectId, setReceiveProjectId] = useState('');

    const { searchValue } = useSearch();

    const openCreateNewModal = (getProjectId) => {
        setCreateModalOpen(true);
        if (getProjectId){
            setReceiveProjectId(getProjectId)
        }
    }
    const createModalClose = () => {
        setCreateModalOpen(false);
        if(receiveProjectId){
            setReceiveProjectId('')
        }
    }

    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);

    const handleExportFormatChange = (event) => {
        setExportFormat(event.target.value);
    };

    const handleSaveImagesChange = (event) => {
        setSaveImages(event.target.checked);
    };

    const handleCustomNameChange = (event) => {
        setCustomName(event.target.value);
    };

    const handleDefaultSettingsChange = (event) => {
        setDefaultSettings(event.target.checked);
    };

    function getVisiblePages(total, current) {
        if (total <= 5) return Array.from({ length: total }, (_, i) => i + 1);
        const pages = [];
        if (current <= 3) {
            pages.push(1, 2, 3, '...', total);
        } else if (current >= total - 2) {
            pages.push(1, '...', total - 2, total - 1, total);
        } else {
            pages.push(1, '...', current, '...', total);
        }

        return pages;
    }

    const handleOkClick = async () => {
        setExportFormatError('');

        if (!exportFormat) {
            setExportFormatError('Please select an export format.');
            return;
        }

        const postData = {
            project_id: exportProjectData.project_id,
            exportFormat: exportFormat,
            saveImages: saveImages,
            customName: customName,
            defaultSettings: defaultSettings,
        };

        try {
            const response = await axiosInstance.post('/project/export', postData, {
                responseType: 'blob',
            });

            // Get the response as a Blob (Binary Large Object)
            const blob = response.data;

            // Create a link element
            const link = document.createElement('a');
            link.href = window.URL.createObjectURL(blob);
            link.download = `${customName || 'project'}.zip`; // Set the download filename

            // Append the link to the document
            document.body.appendChild(link);

            // Trigger the download
            link.click();

            // Remove the link from the document
            document.body.removeChild(link);

            setSuccessMessage('Project exported successfully!');
            setTimeout(() => {
                setSuccessMessage('');
                setOpen(false);
            }, 2000);
        } catch (error) {
            console.error('Error exporting project:', error);
            setSuccessMessage('Error exporting project. Please try again.');
            setTimeout(() => {
                setSuccessMessage('');
            }, 2000);
        }

    };

//     const getProjects = () => {
//         axiosInstance
//             .get(`/specificprojects`)
//             .then((res) => {
//                 const allProjects = res.data.reverse();
// console.log("all projects",allProjects)
//                 const updatedProjects = allProjects.map(project => {
//                     // Create a new project object with the modified image path
//                     const newProject = { ...project }; // Spread the existing project properties
//                     if(newProject.task_mediatype == 'doc'){
//                         let url = convertFirstPageOfPdfToImage(newProject.first_doc_path)
//                         console.log("asdfgh")
//                     }

//                     return newProject; // Return the new project object
//                 });
//                 setProjects(updatedProjects);
//                 // Initial filterData set here, will be refined by the useEffect
//                 setFilterData(updatedProjects);
//                 setTotalPages(Math.ceil(updatedProjects.length / pageSize));
//                 let clients = [];
//                 for (let i = 0; i < updatedProjects.length; i++) {
//                     if (!clients.includes(updatedProjects[i].project_clientname)) {
//                         clients.push(updatedProjects[i].project_clientname)
//                     }
//                 }
//                 setClientFilterData(clients);
//             })
//             .catch((error) => console.error(error));
//     };

    const getProjects = async () => {
        try {
            setIsLoading(true);
            const res = await axiosInstance.get("/specificprojects");
            const allProjects = res.data.reverse();

            const updatedProjects = await Promise.all(
                allProjects.map(async (project) => {
                    const newProject = { ...project };

                    if (newProject.task_mediatype === "doc" && newProject.first_doc_path) {
                        try {
                            const imageData = await commonFunction.convertFirstPageOfPdfToImage(newProject.first_doc_path);
                            newProject.previewImage = imageData; 
                        } catch (err) {
                            console.error("Failed to convert PDF:", err);
                            newProject.previewImage = null;
                        }
                    }

                    return newProject;
                })
            );

            setProjects(updatedProjects);
            setFilterData(updatedProjects);
            setTotalPages(Math.ceil(updatedProjects.length / pageSize));

            const clients = [...new Set(updatedProjects.map(p => p.project_clientname))];
            setClientFilterData(clients);

        } catch (error) {
            console.error("Failed to fetch projects:", error);
        }finally{
            setIsLoading(false);
        }
    };

    const handleOnProjectChange = (selectedValue) => {
        setSelectedProjectFilter(selectedValue);
        // Do anything else with the selectedValue
    };

    const handleClearFilter = (e) => {
        setProjectFilterData([]);
        setSelectedClientFilter(null);
        setSelectedProjectFilter(null);
        setStartDateForDateFilter(null);
        setEndDateForDateFilter(null);
        setSelectedDateFilterField('');
        setCurrentPage(1);
        setTotalPages(Math.ceil(projects.length / pageSize));
        setFilterData(projects); // Reset filterData to all projects
    }

    const handleNextPage = () => {
        if (currentPage !== totalPages) {
            setCurrentPage(currentPage + 1);
        }
    }

    const handlePrevPage = () => {
        if (currentPage !== 1) {
            setCurrentPage(currentPage - 1);
        }
    }

    const handlePageClick = (currentPage) => {
        if (currentPage) {
            setCurrentPage(currentPage);
        }
    }

    const handleOpenShowDetailsMenu = (flag, cardData) => {
        setSelectedCard(cardData);
        setShowDetailsMenu(flag);
    }

    const handleCloseShowDetailsMenu = (flag) => {
        if (showDetailsMenu) {
            setSelectedCard(null);
            setShowDetailsMenu(flag);
        }
    }

    const handleDetailsMenuClick = (operation) => {
        if (operation === 'Edit') {
            openCreateNewModal(selectedCard.project_id)
            // navigate('/newproject', { state: { previousRoute: '/projects', projectId: selectedCard.project_id } })
        } else if (operation === 'Delete') {
            showAlert("Do you want to delete this project?", "warning", {
                showCancelButton: true,
                confirmButtonText: "Yes, Delete",
                cancelButtonText: "Cancel",
                onConfirm: async () => {
                    try {
                        await axiosInstance.delete(`/delete/${selectedCard.project_id}`);
                        showAlert("Project Deleted!", "success");
                        getProjects();
                    } catch (error) {
                        console.error(error);
                    }
                },
                onCancel: () => {
                    console.log("User cancelled delete");
                }
            });
        } else if (operation === 'Export') { //5.5.2
            setExportProjectData(selectedCard);
            handleOpen();
        }
    }

    const handleOnCardClick = (project) => {
        navigate('/projects/tasks', { state: { previousRoute: '/projects', projectId: project.project_id } })
    }

    const toggleDateFilterPopup = (value) => {
        setShowDateFilterPopup(value);
    }

    const handleDateFilterChange = (e) => {
        console.log(e)
        setEndDateForDateFilter(null);
        setStartDateForDateFilter(null);
        setSelectedDateFilterField(e.target.value);
    }

    const onDateChangeForFilter = (e) => {
        if (e.target.name === 'startDate') {
            setStartDateForDateFilter(e.target.value);
        } else if (e.target.name === 'endDate') {
            setEndDateForDateFilter(e.target.value);
        }
    }

    const handleApplyDateFilter = () => {
        setComponentKey(componentKey + 1);
        toggleDateFilterPopup(false)
    }

    useEffect(() => {
        let start = (currentPage - 1) * pageSize;
        let end = start + pageSize;
        let records = filterData.slice(start, end);
        setRecordsPerPage(records);
    }, [currentPage, filterData]);

    useEffect(() => {
        let currentFilteredData = projects; // Start with the full list of projects

        // 1. Apply Search Filter
        if (searchValue) {
            currentFilteredData = currentFilteredData.filter(project =>
                project.project_Name.toLowerCase().includes(searchValue.toLowerCase()) ||
                project.project_clientname.toLowerCase().includes(searchValue.toLowerCase())
                // Add more fields you want to search by, e.g., project.description
            );
        }

        // 2. Apply Date Filtering
        if (startDateForDateFilter || endDateForDateFilter) {
            const startDate = startDateForDateFilter ? new Date(startDateForDateFilter).setHours(0, 0, 0, 0) : null;
            const endDate = endDateForDateFilter ? new Date(endDateForDateFilter).setHours(0, 0, 0, 0) : null;

            currentFilteredData = currentFilteredData.filter((project) => {
                const projectDate = new Date(project.createdDate).setHours(0, 0, 0, 0);

                if (selectedDateFilterField === '>') {
                    return startDate ? projectDate > startDate : true;
                } else if (selectedDateFilterField === '<') {
                    return endDate ? projectDate < endDate : true;
                } else if (selectedDateFilterField === 'Between') {
                    return startDate && endDate ? (projectDate >= startDate && projectDate <= endDate) : true;
                } else {
                    // Single date logic if no filter field is selected, or for exact match
                    const selectedDate = startDate || endDate;
                    return selectedDate ? projectDate === selectedDate : true;
                }
            });
        }

        // 3. Extract client names from currently filtered projects for the client dropdown
        let clients = [];
        for (let i = 0; i < currentFilteredData.length; i++) {
            if (!clients.includes(currentFilteredData[i].project_clientname)) {
                clients.push(currentFilteredData[i].project_clientname);
            }
        }
        setClientFilterData(clients);

        // 4. Filter by selected client
        if (selectedClientFilter) {
            currentFilteredData = currentFilteredData.filter(
                (project) => project.project_clientname === selectedClientFilter
            );
            // After filtering by client, update the project filter data for the project dropdown
            setProjectFilterData(currentFilteredData);
        } else {
            // If no client is selected, clear project filter data
            setProjectFilterData([]);
            setSelectedProjectFilter(null); // Clear selected project filter if client filter is cleared
        }


        // 5. Filter by selected project (only if a client is selected and a project is selected)
        if (selectedClientFilter && selectedProjectFilter) {
            currentFilteredData = currentFilteredData.filter(
                (project) => project.project_Name === selectedProjectFilter
            );
        }

        // Set the final filtered data
        setFilterData(currentFilteredData);
        setTotalPages(Math.ceil(currentFilteredData.length / pageSize));
        setCurrentPage(1); // Reset to first page after filtering
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        projects, // projects should be a dependency because filtering starts from here
        searchValue, // Add searchValue as a dependency
        selectedClientFilter,
        selectedProjectFilter,
        startDateForDateFilter,
        endDateForDateFilter,
        selectedDateFilterField,
        componentKey // For manually triggering date filter re-evaluation
    ]);


    useEffect(() => {
        getProjects();
    }, []);

    const handleClickOutside = (event) => {
        if (!event.target.closest('.dateFilter')) {
            setShowDateFilterPopup(false);
        }
    };

    useEffect(() => {
        document.addEventListener('click', handleClickOutside);
        return () => {
            document.removeEventListener('click', handleClickOutside);
        };
    }, []);

    return (<>
        <div className="main" onClick={() => handleCloseShowDetailsMenu(false)}>
            <div>
                <div className="flex gap-[10px] justify-end">
                    <div className="relative">
                        <button
                            className="dateFilter w-[220px] h-[40px] flex justify-between items-center rounded-[22px] px-[10px] pl-[20px] border text-[15px] leading-none font-normal text-gray-700 bg-white font-poppins shadow-sm hover:bg-gray-50 focus:border-blue-500 focus:outline-none focus:ring-1 focus:ring-primary-color"
                            onClick={() => toggleDateFilterPopup(!showDateFilterPopup)}
                        >
                            <span>
                                {startDateForDateFilter || endDateForDateFilter ? (
                                    selectedDateFilterField === 'Between' ? (
                                        `${new Date(startDateForDateFilter).toLocaleDateString()} to ${new Date(endDateForDateFilter).toLocaleDateString()}`
                                    ) : selectedDateFilterField === '>' ? (
                                        `After ${new Date(startDateForDateFilter).toLocaleDateString()}`
                                    ) : selectedDateFilterField === '<' ? (
                                        `Before ${new Date(endDateForDateFilter).toLocaleDateString()}`
                                    ) : (
                                        // fallback if no filter field is selected, show single selected date
                                        `${new Date(startDateForDateFilter || endDateForDateFilter).toLocaleDateString()}`
                                    )
                                ) : 'Select Date'}
                            </span>
                            <FiCalendar className="text-gray-500" />
                        </button>

                        {showDateFilterPopup && <div className="dateFilter absolute top-11 z-10 rounded-[10px] bg-gray-decent">
                            <div style={{
                                display: 'flex',
                                padding: '20px'
                            }}>
                                <select
                                    id="selectField"
                                    value={selectedDateFilterField}
                                    onChange={handleDateFilterChange}
                                    className="w-[90px] h-[34px] text-sm rounded-md bg-white border border-gray-400 text-gray-800 px-2 py-1 focus:outline-none focus:ring-1 focus:ring-primary-color focus:border-primary-color cursor-pointer shadow-sm"
                                >
                                    <option value="">Select</option>
                                    {dateFilterSelectFieldsOptions?.map((field, index) => (
                                        <option value={field} key={index}>
                                            {field}
                                        </option>
                                    ))}
                                </select>


                                <div className="ml-2">
                                    {['Between', '>', '>=', ''].includes(selectedDateFilterField) && <input
                                        type="datetime-local"
                                        name="startDate"
                                        value={startDateForDateFilter}
                                        onChange={(e) => onDateChangeForFilter(e)}
                                        className="h-[34px] text-sm rounded-md bg-white border border-gray-400 text-gray-800 px-2 py-1 focus:outline-none focus:ring-1 focus:ring-primary-color focus:border-primary-color cursor-pointer shadow-sm"
                                    ></input>}
                                    {selectedDateFilterField === 'Between' && <span className="text-gray-800">to</span>}
                                    {['Between', '<', '<='].includes(selectedDateFilterField) && <input
                                        type="datetime-local"
                                        name="endDate"
                                        value={endDateForDateFilter}
                                        onChange={(e) => onDateChangeForFilter(e)}
                                        className="h-[34px] text-sm rounded-md bg-white border border-gray-400 text-gray-800 px-2 py-1 focus:outline-none focus:ring-1 focus:ring-primary-color focus:border-primary-color cursor-pointer shadow-sm"
                                    ></input>}
                                </div>
                            </div>
                            <div className=" flex justify-end pr-4 pb-4">
                                <button type="button"
                                    className="w-[100px] h-[40px] rounded-[22px] bg-gradient-to-r from-[#C300A0] to-[#00B4D2] flex items-center justify-center text-white transition-transform duration-200 hover:scale-110 hover:shadow-lg"
                                    onClick={() => handleApplyDateFilter()}>
                                    Apply
                                </button>
                            </div>
                        </div>}
                    </div>
                    <div className="w-[220px] relative font-poppins text-[15px]">
                        <Listbox value={selectedClientFilter} onChange={setSelectedClientFilter}>
                            <div className="relative">
                                <Listbox.Button className="relative w-full h-[40px] cursor-pointer rounded-[22px] bg-white border border-gray-300 pl-5 pr-10 text-left shadow-sm focus:outline-none focus:ring-1 focus:ring-primary-color focus:border-primary-color">
                                    <span className="block truncate text-gray-main">
                                        {selectedClientFilter || "Select Client"}
                                    </span>
                                    <span className="pointer-events-none absolute inset-y-0 right-3 flex items-center">
                                        <FaChevronDown className="h-3 w-3 text-gray-400" />
                                    </span>
                                </Listbox.Button>

                                <Listbox.Options className="absolute z-10 mt-0 max-h-60 w-[275px] px-4 overflow-auto rounded-[10px] bg-gray-decent py-1 text-[14px] shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
                                    {clientFilterData?.map((client, index) => (
                                        <Listbox.Option key={index} value={client}>
                                            {({ active }) => (
                                                <div
                                                    className={clsx(
                                                        "relative cursor-pointer select-none py-2 pl-2 pr-8 flex justify-between items-center border-b border-[#28325A26]",
                                                        {
                                                            "text-deep-blue border-deep-blue": active,
                                                            "text-gray-900": !active,
                                                        }
                                                    )}
                                                >
                                                    <span>{client}</span>
                                                    {(selectedClientFilter === client || active) && (
                                                        <span className="absolute right-2 flex items-center justify-center h-[20px] w-[20px] bg-deep-blue rounded-full">
                                                            <FaCheck className="text-white text-[10px]" />
                                                        </span>
                                                    )}
                                                </div>
                                            )}
                                        </Listbox.Option>
                                    ))}
                                </Listbox.Options>
                            </div>
                        </Listbox>
                    </div>

                    <div className="w-[220px] relative font-poppins text-[15px]">
                        <Listbox
                            value={selectedProjectFilter}
                            onChange={handleOnProjectChange}
                            disabled={!projectFilterData || projectFilterData.length === 0}
                        >
                            <div className="relative">
                                <Listbox.Button
                                    className={clsx(
                                        "relative w-full h-[40px] cursor-pointer rounded-[22px] px-[20px] pr-10 text-left shadow-sm text-gray-700 text-[15px] font-normal font-poppins border",
                                        {
                                            "bg-white border-gray-300 focus:outline-none focus:ring-1 focus:ring-primary-color focus:border-primary-color":
                                                projectFilterData?.length > 0,
                                            "bg-gray-100 text-gray-400 cursor-not-allowed border-gray-200": !projectFilterData?.length,
                                        }
                                    )}
                                >
                                    <span className="block truncate">
                                        {selectedProjectFilter || "Select Project"}
                                    </span>
                                    <span className="pointer-events-none absolute inset-y-0 right-3 flex items-center">
                                        <FaChevronDown className="h-3 w-3 text-gray-400" />
                                    </span>
                                </Listbox.Button>

                                {projectFilterData?.length > 0 && (
                                    <Listbox.Options className="absolute z-10 mt-0 max-h-60 w-[275px] px-4 overflow-auto rounded-[10px] bg-gray-decent py-1 text-[14px] shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
                                        {projectFilterData.map((project, index) => (
                                            <Listbox.Option
                                                key={index}
                                                value={project.project_Name}
                                            >
                                                {({ active, selected }) => (
                                                    <div
                                                        className={clsx(
                                                            "relative cursor-pointer select-none py-2 pl-2 pr-8 flex justify-between items-center border-b border-[#28325A26]",
                                                            {
                                                                "text-deep-blue border-deep-blue": active,
                                                                "text-gray-900": !active,
                                                            }
                                                        )}
                                                    >
                                                        <span>{project.project_Name}</span>

                                                        {(selected || active) && (
                                                            <span className="absolute right-2 flex items-center justify-center h-[20px] w-[20px] bg-deep-blue rounded-full">
                                                                <FaCheck className="text-white text-[10px]" />
                                                            </span>
                                                        )}
                                                    </div>
                                                )}
                                            </Listbox.Option>
                                        ))}
                                    </Listbox.Options>
                                )}
                            </div>
                        </Listbox>
                    </div>

                    {/* Remove Filter Button */}
                    <button
                        type="button"
                        onClick={handleClearFilter}
                        className="min-w-[150px] h-[40px] px-6 py-[10px] rounded-[22px] bg-deep-blue text-white text-[15px] font-medium font-['Poppins'] leading-[100%] text-center align-middle transition-transform duration-200 hover:scale-105 hover:shadow-lg"
                    >
                        Clear Filter
                    </button>

                    {/* Gradient + Button */}
                    <button
                        type="button"
                        onClick={() => openCreateNewModal()}
                        className="w-[40px] h-[40px] rounded-[22px] bg-gradient-to-r from-[#C300A0] to-[#00B4D2] flex items-center justify-center text-white transition-transform duration-200 hover:scale-110 hover:shadow-lg"
                    >
                        <svg
                            viewBox="64 64 896 896"
                            focusable="false"
                            data-icon="plus"
                            width="1em"
                            height="1em"
                            fill="currentColor"
                            aria-hidden="true"
                            className="w-4 h-4"
                        >
                            <path d="M482 152h60q8 0 8 8v704q0 8-8 8h-60q-8 0-8-8V160q0-8 8-8z"></path>
                            <path d="M192 474h672q8 0 8 8v60q0 8-8 8H160q-8 0-8-8v-60q0-8 8-8z"></path>
                        </svg>
                    </button>

                </div>
            </div>
            <div className="cardContainer grid grid-cols-4 gap-4 mt-8">
                {recordsPerPage && recordsPerPage.length > 0 ? (recordsPerPage.map((project, index) => (
                    <div className="p-2 border border-light-blue rounded-[10px] relative dark:bg-gray-main" key={index}>
                        <div className="w-full h-[112px] bg-slate-400 rounded-t-[10px] cursor-pointer" onClick={() => handleOnCardClick(project)}>
                            {project.task_mediatype == "image" && project?.first_image_path && (
                                <img className="rounded-t-[10px] object-cover h-[112px] w-full" src={project.first_image_path} alt={project.first_image_path} />
                            )}
                            {project.task_mediatype == "doc" && project?.previewImage && (
                                <img className="rounded-t-[10px] object-cover h-[112px] w-full" src={project.previewImage} alt={project.previewImage} />
                            )}
                        </div>
                        <div className=" px-[4.5px] py-[11px]">
                            <div className="project-name flex justify-between items-center relative">
                                <h3 className="font-poppins font-semibold text-[12px] leading-[100%] tracking-[-0.01em] dark:text-white">
                                    {project?.project_Name.length > 14 ? project.project_Name.slice(0, 14) + "..." : project.project_Name}
                                </h3>
                                <span className="cursor-pointer text-2xl text-primary-color relative" onClick={() => handleOpenShowDetailsMenu(true, project)}>
                                    <TbDotsVertical />
                                    {showDetailsMenu && project.project_id === selectedCard.project_id &&
                                        <div className="absolute right-0 w-[100px] bg-white text-sm text-black border-2 border-[rgba(54,52,52,0.2)] rounded z-10 shadow-[1px_1px_5px_1px_rgba(43,39,39,0.2)]">
                                            {detailsMenuFields.map((field, index) => <div key={index} className="detailsMenu cursor-pointer py-1 px-2" onClick={() => handleDetailsMenuClick(field)} >{field}</div>)}
                                        </div>}
                                </span>
                            </div>
                            <div className="created-date flex justify-between mt-[11px]">
                                <div className="w-1/2">
                                    <div className="font-poppins text-gray-d-100 dark:text-slate-400 font-semibold text-[14px] leading-[18px] tracking-[-0.01em]">
                                        <p>Created On :</p> <p className="font-normal">{new Date(project.createdDate).toLocaleDateString("en-US")}</p>
                                    </div>
                                </div>
                                {project.task_mediatype === "image" ? (
                                    <div className="font-poppins text-gray-d-100 dark:text-slate-400 font-semibold text-[14px] leading-[18px] tracking-[-0.01em]">
                                        <p>Progress:</p>
                                        <p className="font-normal">
                                        {project.labeledImage}/{project.numOfimage} ({project.percentageLabeledImages}%)
                                        </p>
                                    </div>
                                    ) : project.task_mediatype === "doc" ? (
                                    <div className="font-poppins text-gray-d-100 dark:text-slate-400 font-semibold text-[14px] leading-[18px] tracking-[-0.01em]">
                                        <p>Progress:</p>
                                        <p className="font-normal">
                                        {project.labeledDocument}/{project.numOfDocument} ({project.percentageLabeledDocuments}%)
                                        </p>
                                    </div>
                                    ) : (
                                    <div className="font-poppins text-gray-d-100 dark:text-slate-400 font-semibold text-[14px] leading-[18px] tracking-[-0.01em]">
                                        <p>Progress:</p>
                                        <p className="font-normal">0/0 (0%)</p>
                                    </div>
                                    )}
                            </div>
                        </div>

                    </div>))
                    ) : (
                        !isLoading && <div className="col-span-4 text-center text-gray-600 dark:text-gray-400">
                            No records found.
                        </div>
                    )
                }

                {/* 5.5.2 */}
                <Modal
                    open={open}
                    onClose={handleClose}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"
                >
                    <div className="modal-overlay">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h2>Export project #{exportProjectData ? exportProjectData.project_Name + " " : "..."} as a dataset</h2>
                                <span className="close-button" onClick={handleClose}>&times;</span>
                            </div>
                            <div className="modal-body">
                                <div className="form-group">
                                    <label htmlFor="export-format">Export format <span className="required">*</span></label>
                                    <select id="export-format" value={exportFormat} onChange={handleExportFormatChange}>
                                        <option value="">Select file format</option>
                                        <option value="coco">Coco</option>
                                        <option value="yolo">Yolo</option>
                                        <option value="json">Json</option>
                                        <option value="xml">XML</option>
                                    </select>
                                    {exportFormatError && <div className="error-message">{exportFormatError}</div>}
                                </div>
                                <div className="form-group">
                                    <label htmlFor="save-images">Save images</label>
                                    <label className="switch">
                                        <input type="checkbox" id="save-images" checked={saveImages} onChange={handleSaveImagesChange} />
                                        <span className="slider round"></span>
                                    </label>
                                </div>
                                <div className="form-group">
                                    <label htmlFor="custom-name">Custom name</label>
                                    <div className="input-group">
                                        <input type="text" id="custom-name" placeholder="Custom name for a dataset" value={customName} onChange={handleCustomNameChange} />
                                        <span className="input-group-addon">.zip</span>
                                    </div>
                                </div>
                                <div className="form-group">
                                    <label className="switch">
                                        <input type="checkbox" id="default-settings" checked={defaultSettings} onChange={handleDefaultSettingsChange} />
                                        <span className="slider round"></span>
                                    </label>
                                    <label htmlFor="default-settings">Use default settings</label>
                                    <span className="help-icon">?</span>
                                </div>
                                {successMessage && <div className="success-message">{successMessage}</div>}
                            </div>
                            <div className="modal-footer">
                                <button className="cancel-button" onClick={handleClose}>Cancel</button>
                                <button className="ok-button" onClick={handleOkClick}>OK</button>
                            </div>
                        </div>
                    </div>
                </Modal>
            </div>
            <div className=" flex justify-center">
                {recordsPerPage?.length > 0 && (
                    <div className="paginationContainer flex justify-center mt-6">
                        <div className="flex items-center space-x-2 dark:text-white">
                            {/* Prev button */}
                            <button
                                type="button"
                                disabled={currentPage === 1}
                                onClick={handlePrevPage}
                                className={`w-10 h-10 rounded-full border border-gray-300 text-lg flex items-center justify-center ${currentPage === 1 ? 'cursor-not-allowed text-gray-400' : 'hover:bg-gray-100 dark:text-gray-main'
                                    }`}
                            >
                                <FiChevronLeft />
                            </button>

                            {/* Page numbers */}
                            {getVisiblePages(totalPages, currentPage).map((page, index) =>
                                page === '...' ? (
                                    <div key={index} className="w-10 h-10 flex items-center justify-center text-gray-500">
                                        ...
                                    </div>
                                ) : (
                                    <button
                                        key={index}
                                        onClick={() => handlePageClick(page)}
                                        className={`w-10 h-10 rounded-full border border-gray-300 text-lg flex items-center justify-center ${currentPage === page ? 'bg-gray-300 font-semibold dark:text-gray-main' : 'hover:bg-gray-100'
                                            }`}
                                    >
                                        {page}
                                    </button>
                                )
                            )}

                            {/* Next button */}
                            <button
                                type="button"
                                disabled={currentPage === totalPages}
                                onClick={handleNextPage}
                                className={`w-10 h-10 rounded-full border border-gray-300 text-lg flex items-center justify-center ${currentPage === totalPages ? 'cursor-not-allowed text-gray-400' : 'hover:bg-gray-100'
                                    }`}
                            >
                                <FiChevronRight />
                            </button>
                        </div>
                    </div>
                )}
            </div>

            <Modal
  keepMounted
  open={createModalOpen}
  onClose={createModalClose}
  aria-labelledby="keep-mounted-modal-title"
  aria-describedby="keep-mounted-modal-description"
  slotProps={{
    backdrop: {
      sx: {
        backgroundColor: 'rgba(0, 0, 0, 0.3)',
        backdropFilter: 'blur(2px)',
        WebkitBackdropFilter: 'blur(2px)',
      },
    },
  }}
>
  <div className="relative w-[600px] bg-white shadow-md px-5 py-7 rounded-xl absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2">
    
    <button
  onClick={createModalClose}
  className="absolute top-3 right-3 w-8 text-xl h-8 bg-gradient-to-r from-[#C300A0] to-[#00B4D2] text-white rounded-full flex items-center justify-center text-lg hover:scale-110 transition-transform"
  aria-label="Close"
>
  &times;
</button>

    {/* Modal Content */}
    {createModalOpen && (
      <CreateProject key={receiveProjectId || 'new'} projectId={receiveProjectId} />
    )}
  </div>
</Modal>
           <Loader loading={isLoading}/>
        </div>           
    </>)
}

export default Project;